export const EN_TRANSLATION = {
  "COMPANIES_UPDATE_SUCCESS": "Updated",
  "LIMIT": "Limit",
  "ACCOUNT_ID": "Account id",
  "SIGNIN": "Log in",
  "SIGNIN_WELCOME_MESSAGE": "Log in",
  "SIGNIN_EMAIL": "Email",
  "SIGNIN_PASSWORD": "Password",
  "SIGNIN_REMEMBER_ME": "Remember me",
  "SIGNIN_SUBMIT": "Log in",
  "SIGNIN_FORGOT_PASSWORD": "Forgot your password?",
  "SIGNIN_ERROR": "Wrong data",
  "PASSWORD_HEADING": "Reset password",
  "PASSWORD_EMAIL": "Email",
  "PASSWORD_SUBMIT": "Reset password",
  "PASSWORD_REQUEST_SUCCESS": "Check email to reset password",
  "PASSWORD_REQUEST_ERROR": "Something has gone wrong…",
  "PASSWORD_RESET_SUCCESS": "Your password has been changed, you will now be logged in",
  "PASSWORD_RESET_ERROR": "Something has gone wrong…",
  "PASSWORD_NEW_PASSWORD": "New password",
  "PASSWORD": "Password",
  "DASHBOARD": "View",
  "DASHBOARD_HEADING": "Welcome to the application",
  "GO_TO_DETAIL": "See details",
  "BOOKING_CROSSING": "Crossing booking",
  "BOOKING_OPERATOR": "Shipowner",
  "BOOKING_RELATION": "Route",
  "BOOKING_DEPARTURE_DATE": "Date",
  "BOOKING_DEPARTURE_HOURS": "Hour",
  "BOOKING_DATA": "Crossing data",
  "BOOKING_VEHICLE": "Vehicle data",
  "BOOKING_LENGTH": "Length [m]",
  "BOOKING_WEIGHT": "Load Weight [t]",
  "BOOKING_LIST_RESERVATION_NUMBER": "Reservation no.",
  "BOOKING_LIST_DATE": "Date",
  "BOOKING_LIST_OPERATOR": "Shipowner",
  "BOOKING_LIST_STATE": "Status",
  "BOOKING_LIST_RELATION": "Route",
  "BOOKING_LIST_VEHICLE": "Vehicle",
  "BOOKING_LIST_CONTRACTOR": "Contractor",
  "BOOKING_NUMBER": "Reservation no.",
  "DEPARTURE_DATE": "Date",
  "BOOKING_STATUS": "Status",
  "ROUTE": "Route",
  "VEHICLE_NUMBER": "Vehicle",
  "CONTRACTOR": "Contractor",
  "CREATOR": "Contracting authority",
  "BOOKING_LIST_WORKING": "Current",
  "BOOKING_LIST_HISTORY": "History",
  "BOOKING_LIST_NEW": "New",
  "BOOKING_UPDATE_SUCCESS": "The crossing has been updated",
  "BOOKING_VEHICLE_TYPE": "Vehicle type",
  "BOOKING_VEHICLE_NUMBER": "Vehicle no.",
  "BOOKING_REF": "Your ref.",
  "BOOKING_CARGO_NUMBER": "Trailer no.",
  "BOOKING_NUMBER_OF_DRIVERS": "Number of drivers",
  "BOOKING_DESCRIPTION": "Type of cargo",
  "BOOKING_CONTRACTOR": "Contractor",
  "BOOKING_LIST_CREATOR": "Contracting authority",
  "BOOKING_STATUS_MODIFIED": "Modified",
  "BOOKING_STATUS_MODIFIED_WAITLIST": "Modified - WL",
  "BOOKING_STATUS_DESTROYED": "Cancelled",
  "BOOKING_STATUS_DESTROYED_PENDING": "Awaiting cancellation",
  "BOOKING_STATUS_WAITING": "Waiting",
  "BOOKING_STATUS_CONFIRMED": "Confirmed",
	"BOOKING_STATUS_WAITLIST": "Waiting - WL",
  "BOOKING_STATUS_EXPIRED": "Expired",
  "BOOKING_STATUS_SUCCESS": "Realized",
  "BOOKING_STATUS_ERROR": "Error",
  "BOOKING_CREATE": "Make a booking",
  "BOOKING_CREATE_CATCH_LIMIT": "Quota limit for crossing exceeded",
  "BOOKING_CREATE_RETURN": "Return",
  "EMPTY_VEHICLE": "Empty vehicle",
  "DRIVER_PHONE_NUMBER": "Driver's phone number",
  "DRIVER_PHONE_NUMBER_TOOLTIP": "Phone number for SMS notifications",
  "SCANDLINES_DISCLAIMER": "Note: If you have dangerous cargo, oversized cargo or are transporting animals make a reservation through the standard route to avoid additional costs.",
  "TUNNEL_DISCLAIMER": "For trucks with height of more then 4,05 m, contact directly to the forwarder. It is possible to book only class 5 and 6 and width up to 2,55 m",
  "BOOKING_UPDATE_SUBMIT": "Edit",
  "PLUG_IN": "Plug in",
  "BOOKING_UPDATE": "Booking update",
  "BOOKING_SELECT_RELATION": "Select route",
  "BOOKING_BOOKING_VALUE": "Amount",
  "BOOKING_BOOKING_VALUE_OVERRIDE": "Another amount",
  "BOOKING_IS_BOOKING_VALUE_OVERRIDE": "Overwrite the amount?",
  "BOOKING_PAYMENT_STATUS": "Payment status",
  "BOOKING_LIMIT": "The remaining limit for your company",
  "BOOKING_LIMIT_WRONG": "Something went wrong",
  "BOOKING_INVOICE_ACCOUNT_ID": "Settlement account",
  "USERS_CREATE": "Users created",
  "USERS_DATA": "Users data",
  "USERS_UPDATE_EMAIL": "Email",
  "USERS_UPDATE_FIRSTNAME": "Name",
  "USERS_UPDATE_LASTNAME": "Surname",
  "USERS_UPDATE_PHONE": "Phone number",
  "USERS_UPDATE_PASSWORD": "Password",
  "USERS_UPDATE_PASSWORD_CONFIRM": "Confirm password",
  "USERS_UPDATE": "Update user",
  "USER_SUSPENDED": "Locked",
  "USER_CREATE_SUCCESS": "User created",
  "USERS_UPDATE_SUCCESS": "User updated",
  "FORM_SEARCH_PLACEHOLDER": "Search",
  "COMPANIES_CREATE": "Create a company",
  "COMPANIES_DATA": "Company data",
  "COMPANIES_USERS": "Users",
  "APP_SETTINGS": "Application settings",
  "FIRSTNAME": "Name",
  "LASTNAME": "Surname",
  "EMAIL": "Email",
  "POST_CODE": "Postal code",
  "NAME": "Name",
  "VAT_ID": "Vat id",
  "STREET": "Street",
  "CITY": "City",
  "COUNTRY": "Country",
  "APP_SETTINGS_UPDATE": "Update the application",
  "SETTINGS_UPDATE_SUCCESS": "Updated data",
  "SETTINGS_CREATED_SUCCESS": "Data recorded",
  "SETTINGS_DELETED_SUCCESS": "Deleted data",
  "ADMIN": "Admin panel",
  "LOGOUT": "Logout",
  "LINE_ONE": "Name",
  "LINE_TWO": "Vat id",
  "LINE_THREE": "Line three",
  "LINE_FOUR": "Line four",
  "LINE_FIVE": "Line five",
  "UPLOAD_AVATAR_SENDED": "Avatar has been updated",
  "CANCEL": "Cancel",
  "PACKAGE": "Road train",
  "OTHER": "Other",
  "ROADTRAIN": "Road Train or longer",
  "CAR": "Passenger car",
  "CCHNEW": "Coach",
  "CON": "Conteiner",
  "EXCVAN": "Caravan",
  "GLASS": "Car with rack for transporting glass",
  "HBOX": "Car with horse trailer",
  "LORRY": "Lorry",
  "LT": "Lorry with trailer",
  "ST": "Tractor",
  "STKR": "Tank",
  "TT": "Tractor",
  "TTKR": "Tank",
  "UNIT": "Unit",
  "VAN": "Van",
  "VANTLR": "Van with trailer",
  "CONFIRM_DESTROY_RECORD": "are you sure you want to delete the record?",
  "DESTROY_RECORD": "delete",
  "UPDATE": "save",
  "ADD": "add",
  "NEW": "new",
  "HISTORY_BACK_BUTTON": "back",
  "EMPTY_PAGE": "no records to display",
  "NOTFOUND": "we found nothing at the address indicated",
  "UNAUTHORIZED": "your session has expired",
  "FORBIDDEN": "no access",
  "NONE": "no data",
  "PARTIAL": "partly",
  "FULL": "paid",
  "ADMIN_BOOKING_LIST": "list of bookings",
  "BOOKING_MULTI_TITLE": "make a booking",
  "BOOKING_MULTI_ROUTE": "route",
  "BOOKING_MULTI_DATE": "date",
  "BOOKING_MULTI_TIME": "time",
  "BOOKING_MULTI_REF": "your ref.",
  "BOOKING_MULTI_VEHICLE_TYPE": "Vehicle type",
  "BOOKING_MULTI_VEHICLE_WIDTH": "Length [m]",
  "BOOKING_MULTI_WEIGHT": "Weight [t]",
  "BOOKING_MULTI_VEHICLE_PLATE": "Vehicle no.",
  "BOOKING_MULTI_TRAILER_PLATE": "Trailers no",
  "BOOKING_MULTI_CANCEL": "Cancel",
  "BOOKING_MULTI_BOOK": "Make a booking",
  "BOOKING_MULTIPLY": "Multibooking",
  "BOOKING_NO_OF_BOOKINGS": "Number of crossings",
  "AR": "Artic 16,50 m",
  "CB": "Tractor",
  "CT": "Caravan",
  "DT": "Trailer",
  "HB": "Hrse trailer",
  "RD": "Lorry/van",
  "RT": "Road train 18 m",
  "PRINT_DOC": "Confirmation",
  "AGREEMENT_TITLE": "Approvals",
  "AGREEMENT_DESC": "Please review the consents below and mark all of them.",
  "AGREEMENT_CHECK_ALL": "Check all",
  "AGREEMENT_TANDC": "Oświadczam, że zapoznałem/am się z Warunkami korzystania - dostępnymi na stronie internetowej <a href=\"https://www.promyskat.pl/regulamin-serwisu\" target=\"_blank\">Regulamin</a> i akceptuję wszystkie zawarte w nim warunki.<br>Administratorem Twoich danych osobowych jest: SKAT Transport P.S.A. z siedzibą w Gdańsku.",
  "AGREEMENT_PRIVACY": "How we process your personal data can be found in our <a href=\"https://www.promyskat.pl/polityka-prywatnosci\" target=\"_blank\">Privacy Policy</a> available on the website: Privacy Policy",
  "AGREEMENT_PRIVACY2": "I declare that I have read the <a href=\"https://www.promyskat.pl/polityka-prywatnosci\" target=\"_blank\">Privacy Policy</a>",
  "AGREEMENT_CONFIRM": "Send",
  "BOOKING_QUEUE_RESET": "Delete list",
  "WAITING_FOR_BOOKINGS": "Waiting for new booking",
  "SPEDITOR_MODE": "Forwarder",
  "STANDARD_MODE": "Standard",
  "MANAGER_MODE": "Manager",
  "CUSTOMER": "Customer",
  "LANG": "Language",
  "PHONE": "Phone no",
  "ERROR_NO_SPEDITOR_ID": "No forwarder id",
  "USERS_SPEDITOR_ID": "Forwarder id",
  "ATTACHMENT": "Attachment",
  "SMS_NOTIFICATION": "SMS notification",
  "EMAIL_NOTIFICATION": "Email notification",
  "BPP": "Truck Trailer",
  "BPO": "Lorry",
	"TE": "Trailer",
	"CH": "Chassis",
  "UPLOAD_VEHICLES": "Vehicles configuration",
	"UPLOAD": "Upload",
	"DELETE": "Delete",
	"SAVE": "Save",
	"UPLOADED_VEHICLES_CREATED_SUCCESS": "Changes saved",
  "UPLOADED_VEHICLES_BAD_FILE": "Incorrect file",
  "ACTIVITY_HOURS": "Availability hours",
  "ACTIVITY_HOURS_ACTIVE": "Limited hours",
  "ACTIVITY_HOURS_START": "From",
  "ACTIVITY_HOURS_END": "To",
  "BOOKINGS_NOT_PERMITTED_DUE_TO_AVAILABILITY_HOURS": "Currently, it is not possible to make new bookings",
  "ADR_INFO": "UN, grupa i klasa",
  "FGTVAN": "FGTVAN",
  "OVERSIZED": "Oversize",
  "BOOKING_OVERSIZED_WIDTH": "Width [m]",
	"BOOKING_OVERSIZED_HEIGHT": "Height [m]",
	"BOOKING_OVERSIZED_WEIGHT": "Weight [t]",
  "ACCOUNT_MANAGER": "Account manager",
  "BOOKING_ADMIN": "Booking Admin",
  "ADD_FILE": "Add File",
  "CLEAR_FILE": "Remove",
  "ADR_DECLARATION": "ADR Declaration",
  "ADR_DISCLAIMER": "A Dangerous Goods Declaration must be provided. You can attach it below.",
  "SEMITRAILER": "Semi Trailer",
  "TRUCKTRAILER": "Truck Trailer",
  "ARTIC": "Artic",
  "TRAILER": "Trailer",
  "VEHICLE": "Vehicle",
  "TANKER": "Tanker",
  "TRACTOR": "Tractor",
  "AFTERHOURS_TITLE": "Ważna informacja",
	"AFTERHOURS_DESC": "Rezerwacja nie została zmieniona ani anulowana.\nUprzejmie prosimy o kontakt z numerem dyżurnym w celu uzyskania dalszych informacji.",
	"AFTERHOURS_PHONE": "+48 532 773 112",
  "AFTERHOURS_CONFIRM": "Rozumiem"
}


/** WEBPACK FOOTER **
 ** ./frontend/components/translates/en.const.js
 **/